import { z } from "zod"
import { Language } from "@/types/__generated__/union-types"

export const PrescriptionSchema = z.object({
  language: z.custom<Exclude<Language, "ENGLISH">>(),
  healthcareProviderId: z.string().nullable(),
  medicationIds: z.array(z.string()).min(1, {
    message: "common.fieldErrorList.requiredField",
  }),
})

export type Prescription = z.infer<typeof PrescriptionSchema>
